import { Component, computed, DestroyRef, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { OverlayModule } from '@angular/cdk/overlay';
import { UserStore } from 'features/user/store/user.store';
import { UserAuthService } from 'features/user/services/user-auth.service';
import { UserService } from 'features/user/services/user.service';
import { AvatarComponent } from 'shared/components/avatar/avatar.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TestModeService } from '../../services/test-mode.service';

@Component({
  selector: 'app-system-admin-header',
  standalone: true,
  templateUrl: './system-admin-header.component.html',
  styleUrls: ['./system-admin-header.component.scss'],
  imports: [
    CommonModule,
    RouterLink,
    RouterLinkActive,
    MatButtonModule,
    MatIconModule,
    OverlayModule,
    AvatarComponent,
  ],
})
export class SystemAdminHeaderComponent {
  private router = inject(Router);
  private userStore = inject(UserStore);
  private authService = inject(UserAuthService);
  private userService = inject(UserService);
  private destroyRef = inject(DestroyRef);
  private testModeService = inject(TestModeService);

  isMenuOpen = false;
  userName = signal<string>('');

  activeProfile = computed(() => this.userStore.activeProfile());

  navLinks = computed(() => [
    { path: '/system-admin/dashboard', label: 'Dashboard' },
    ...(this.testModeService.testModeEnabled()
      ? [{ path: '/system-admin/testing', label: 'Testing' }]
      : []),
    { path: '/system-admin/security', label: 'Security' },
    { path: '/system-admin/profiles', label: 'Profiles' },
    { path: '/system-admin/settings', label: 'Settings' },
  ]);

  constructor() {
    this.testModeService.ensureLoaded()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
    this.userService.getUserData().subscribe(data => {
      this.userName.set(data.userInfo.firstName + ' ' + data.userInfo.lastName);
    });
  }

  navigateTo(path: string, event: MouseEvent): void {
    event.preventDefault();
    this.router.navigate([path]);
  }

  goToMainApp(): void {
    this.router.navigate(['/dashboard']);
  }

  logout(): void {
    this.authService.logout().pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe();
  }

  isActive(path: string): boolean {
    return this.router.url.startsWith(path);
  }
}
